import React, { useState, useEffect } from "react";
import "../styles/NavBar.css";
import logo from "../assets/logo5.png";
import { FaGithub, FaLinkedin, FaBars } from "react-icons/fa";

const sections = [
  { id: "home", label: "Home" },
  { id: "about", label: "About Me" },
  { id: "experience", label: "Experience" },
  { id: "projects", label: "Projects" },
];

const NavBar: React.FC = () => {
  const [menuOpen, setMenuOpen] = useState(false);
  const [activeSection, setActiveSection] = useState("home");
  const [isVisible, setIsVisible] = useState(false);

  const toggleMenu = () => {
    setMenuOpen(!menuOpen);
  };

  const handleNavClick = (id: string) => {
    setMenuOpen(false);
    const section = document.getElementById(id);
    if (section) {
      if (section.id == "home") {
        window.scrollTo(0, 0);
      }
      else {
        section.scrollIntoView({ behavior: "smooth" });
      }
    }
  };

  useEffect(() => {
    const handleScroll = () => {
      const scrollPosition = window.scrollY + 80;
      let current = "home";
      for (const section of sections) {
        const el = document.getElementById(section.id);
        if (el && el.offsetTop <= scrollPosition) {
          current = section.id;
        }
      }
      setActiveSection(current);

      if (window.scrollY > 80) {
        setIsVisible(true);
      } else {
        setIsVisible(false);
      }
    };
    window.addEventListener("scroll", handleScroll);
    handleScroll();
    return () => window.removeEventListener("scroll", handleScroll);
  }, []);

  return (
    <nav className={`navbar${isVisible ? " visible" : ""}${menuOpen ? " menu-open" : ""}`}>
      <a href="#home" onClick={e => { e.preventDefault(); handleNavClick("home"); }}>
        <img src={logo} alt="Logo" className="navbar-logo" />
      </a>

      <div className={`nav-links ${menuOpen ? "active" : ""}`}>
        {sections.map(section => (
          <a
            key={section.id}
            href={`#${section.id}`}
            className={`nav-link${activeSection === section.id ? " active" : ""}`}
            onClick={e => { e.preventDefault(); handleNavClick(section.id); }}
          >
            {section.label}
          </a>
        ))}
      </div>

      <div className="social-icons">
        <a
          href="https://github.com/vdrongow"
          target="_blank"
          rel="noopener noreferrer"
          className="icon-link"
        >
          <FaGithub className="icon" />
        </a>
        <a
          href="https://www.linkedin.com/in/vivienne-drongowski-413187263/"
          target="_blank"
          rel="noopener noreferrer"
          className="icon-link"
        >
          <FaLinkedin className="icon" />
        </a>
      </div>

      <button className="navbar-toggle" onClick={toggleMenu}>
        <FaBars />
      </button>
    </nav>
  );
};

export default NavBar;
